import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type RailCardDeleteModalState = boolean;

const initialRailCardDeleteModalState: RailCardDeleteModalState = false;

const railCardDeleteModalSlice = createSlice({
  name: "RailCardDeleteModal",
  initialState: initialRailCardDeleteModalState,
  reducers: {
    openDeleteCardModalAction: () => {
      return true;
    },
    closeDeleteModalAction: () => {
      return false;
    },
  },
});

const railCardDeleteModalBaseSelector = createBaseSelector(railCardDeleteModalSlice);

registerSlice([railCardDeleteModalSlice]);

export const railCardDeleteModalStore = {
  actions: railCardDeleteModalSlice.actions,
  selectors: {
    railCardDeleteModal: createSelector(railCardDeleteModalBaseSelector, (s) => s),
  },
};
